module.exports = __webpack_public_path__ + "img/warning-icon.baf2b18f.svg";